import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import ProjectDetail from "@/pages/ProjectDetail";

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
        <LangProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/portfolio/:slug" element={<ProjectDetail />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </LangProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
